// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"188":"b97f732efc91ec12","885":"8fc7487abddeee82","965":"b3d7bcd27083477e"}[chunkId] + ".css";
};